import { AddBusiness } from "@mui/icons-material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import PersonPinCircleIcon from "@mui/icons-material/PersonPinCircle";
import SportsKabaddiIcon from "@mui/icons-material/SportsKabaddi";
import SportsVolleyballIcon from "@mui/icons-material/SportsVolleyball";
import { Button, CircularProgress, TextField } from "@mui/material";
import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import { API_URLS } from "../config/APIUrls";
import axiosInstance from "../config/axios";
import { useLocation, useNavigate } from "react-router-dom";

const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const today = new Date().toISOString().split("T")[0];

  const [activeFilter, setActiveFilter] = useState("today");
  const [startDate, setStartDate] = useState(location.state?.start_date || today);
  const [endDate, setEndDate] = useState(location.state?.end_date || today);
  const [zoneId, setZoneId] = useState(location.state?.zone_id || "");

  const { isLoading, data: count_info, refetch } = useQuery(
    ["master_dashboard", activeFilter, startDate, endDate, zoneId],
    () =>
      axiosInstance.post(API_URLS.master_dashboard, {
        zone_id: zoneId,
        f_type: activeFilter,
        start_date: startDate,
        end_date: endDate,
      }),
    { refetchOnWindowFocus: false }
  );

  const count_info_data = count_info?.data?.response || {};

  const { data: block } = useQuery(
    ["master_main_dashboard", activeFilter, startDate, endDate],
    () =>
      axiosInstance.post(API_URLS.master_main_dashboard, {
        f_type: "all",
        start_date: startDate,
        end_date: endDate,
      }),
    { refetchOnWindowFocus: false }
  );

  const block_data = block?.data?.response || [];

  useEffect(() => {
    if (activeFilter) refetch();
  }, [activeFilter, startDate, endDate, zoneId, refetch]);

  const handleZoneChange = (e) => {
    setZoneId(e.target.value);
  };

  const data = [
    { id: 1, item: "Total Present", count: count_info_data.today_in_emp || 0, icon: <PersonPinIcon className="!h-12 !w-12 !text-[#2a2785]" />, type: "attendance" },
    { id: 2, item: "Present(Late)", count: count_info_data.today_in_lp_emp || 0, icon: <AccountBalanceWalletIcon className="!h-12 !w-12 !text-[#2a2785]" />, type: "attendance" },
    { id: 3, item: "Present On-Time", count: count_info_data.today_in_np_emp || 0, icon: <SportsKabaddiIcon className="!h-12 !w-12 !text-[#2a2785]" />, type: "attendance" },
    { id: 4, item: "Total Absent", count: count_info_data.today_absent || 0, icon: <PersonPinIcon className="!h-12 !w-12 !text-[#2a2785]" />, type: "attendance" },
    { id: 5, item: "Total HalfDay", count: count_info_data.today_halfday || 0, icon: <PersonPinIcon className="!h-12 !w-12 !text-[#2a2785]" />, type: "attendance" },
    { id: 10, item: "Out", count: count_info_data.today_out_emp || 0, icon: <AddBusiness className="!h-12 !w-12 !text-[#2a2785]" />, type: "attendance" },
    { id: 11, item: "Out(Early)", count: count_info_data.today_out_eo_emp || 0, icon: <AddBusiness className="!h-12 !w-12 !text-[#2a2785]" />, type: "attendance" },
    { id: 12, item: "Out On-Time", count: count_info_data.today_out_no_emp || 0, icon: <AddBusiness className="!h-12 !w-12 !text-[#2a2785]" />, type: "attendance" },
    { id: 13, item: "Total Emp", count: count_info_data.total_emp || 0, icon: <PersonPinCircleIcon className="!h-12 !w-12 !text-[#2a2785]" />, type: "attendance" },
    // { id: 6, item: "Leave(Approved)", count: count_info_data.today_leave_approved || 0, icon: <SportsVolleyballIcon className="!h-12 !w-12 !text-[#2a2785]" />, type: "leave" },
    // { id: 7, item: "Leave(Cancelled)", count: count_info_data.today_leave_cancelled || 0, icon: <SportsKabaddiIcon className="!h-12 !w-12 !text-[#2a2785]" />, type: "leave" },
    // { id: 8, item: "Leave(Pending)", count: count_info_data.today_leave_pending || 0, icon: <AddBusiness className="!h-12 !w-12 !text-[#2a2785]" />, type: "leave" },
    // { id: 9, item: "Leave(Rejected)", count: count_info_data.today_leave_rejected || 0, icon: <PersonPinCircleIcon className="!h-12 !w-12 !text-[#2a2785]" />, type: "leave" },

  ];

  const statusMap = {
    "Total Present": "P",
    "Present(Late)": "P",
    "Present On-Time": "P",
    "Total Absent": "A",
    "Total HalfDay": "HD",
  };

  const leaveStatusMap = {
    "Leave(Approved)": "Approved",
    "Leave(Pending)": "Pending",
    "Leave(Rejected)": "Rejected",
    "Leave(Cancelled)": "Cancelled",
  };


  const handleCardClick = (item) => {
    if (item.item === "Total Emp") {
      navigate("/employee_registration", {
        state: {
          zone_id: zoneId,
        },
      });
      return;
    }
    if (item.type === "leave") {
      navigate("/emp_leave_report", {
        state: {
          zone_id: zoneId,
          start_date: startDate,
          end_date: endDate,
          status: leaveStatusMap[item.item] || "",
        },
      });
    } else {
      navigate("/employee_attendance", {
        state: {
          zone_id: zoneId,
          start_date: startDate,
          end_date: endDate,
          status: statusMap[item.item] || "",
        },
      });
    }
  };


  return (
    <div className="p-5">
      {/* Filters */}
      <div className="flex gap-2 mb-5 flex-wrap">
        {/* {["all", "today", "yesterday", "this_month", "last_month"].map((f) => (
          <Button
            key={f}
            size="small"
            variant={activeFilter === f ? "contained" : "outlined"}
            onClick={() => setActiveFilter(f)}
          >
            {f.replace("_", " ").toUpperCase()}
          </Button>
        ))} */}
        {/* Zone select */}
        <div className="flex items-center gap-3 mb-5">
          <span>Select Block:</span>
          <select value={zoneId} onChange={handleZoneChange} className="px-2 py-1 border rounded border-gray-500">
            {block_data.map((zone) => (
              <option key={zone.zone_id} value={zone.zone_id}>
                {zone.zone_name}
              </option>
            ))}
          </select>
        </div>
        {/* <p className="mt-2">Select Date : </p>
        <TextField
          size="small"
          type="date"
          label="Start Date"
          InputLabelProps={{ shrink: true }}
          value={startDate}
          onChange={(e) => {
            setStartDate(e.target.value);
            setActiveFilter("date");
          }}
        />
        <TextField
          size="small"
          type="date"
          label="End Date"
          InputLabelProps={{ shrink: true }}
          value={endDate}
          onChange={(e) => {
            setEndDate(e.target.value);
            setActiveFilter("date");
          }}
        />

        <Button size="small" variant="contained" onClick={() => refetch()} disabled={!startDate || !endDate}>
          Fetch
        </Button> */}

      </div>



      {/* Dashboard cards */}
      {isLoading ? (
        <div className="w-full h-full flex justify-center items-center">
          <CircularProgress />
        </div>
      ) : (
        <div className="grid lg:grid-cols-6 md:grid-cols-3 sm:grid-cols-1 gap-4">
          {data.map((i) => (
            <div
              key={i.id}
              className="text-center bg-gray-300 bg-opacity-75 rounded-lg py-3 cursor-pointer hover:shadow-lg transition duration-200"
              onClick={() => handleCardClick(i)}
            >
              <div className="text-lg pt-1 font-bold">{i.icon}</div>
              <p className="font-bold text-xs">{i.item}</p>
              <p className="font-extrabold text-blue-700 text-lg">{i.count}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dashboard;
